import React from 'react';
import { RegistrationForm } from '../../components/astrologer/registration';
import { RegistrationProvider } from '../../context/RegistrationContext';

const RegisterPage = () => {
  return (
    <RegistrationProvider>
      <RegistrationForm />
    </RegistrationProvider>
  );
};

export default RegisterPage;
